import { useCallback } from 'react'
import get from 'lodash.get'

import { signUpStepsData } from 'components/modals/v2/auth/sign_up_additional_details_modal/helpers/signup_steps_helper'
import { initializeAlbums } from 'components/views/logged_out/SignUp/Helpers'
import AuthHelper from 'helpers/auth_helper'
import ScAnalytics, { actions } from 'classes/sc_analytics'
import { modalEnum } from 'components/modals/v2/modal'
import QueryHelpers from 'helpers/query_helpers'
import { useModalContext } from 'hooks/use_context'
import ApplicationHelper from 'helpers/application_helper'

export const buildGa4ImageStepAttrs = (user, user_logo_filled, signup_divided_steps_flow) => {
  const profile = user.profiles[0]
  const profile_type = [get(profile, 'data.gender'), get(profile, 'profile_type')].filter((v) => !!v).join(' ')

  const { intent_role } = user
  let oauth
  if (user.google_id) oauth = 'google'

  return { intent_role, profile_type, user_logo_filled, signup_divided_steps_flow, oauth }
}

const useSubmitLogo = ({ onClose, setError }) => {
  const modalContext = useModalContext()

  const sendImageStepEvent = useCallback((user_logo_filled) => {
    const user = AuthHelper.currentUser()
    if (!user) return

    const eventParams = buildGa4ImageStepAttrs(user, user_logo_filled, true)
    ScAnalytics.sendMetric(actions.userCreateFunnel.image, eventParams)
  }, [])

  return useCallback(
    async (values) => {
      const skipped = values[signUpStepsData.imagePostpone.field]

      if (!skipped) {
        const data = values.image
        if (!data) return console.log('data key is empty')
        const images = [{ image: data.originalBase64, crop: data.crop }]
        const result = await initializeAlbums(images)
        if (result !== 'success') return setError(result)
        await AuthHelper.loadFromBackend()
      }

      sendImageStepEvent(!skipped)
      onClose()

      const successScreen = QueryHelpers.getParam(QueryHelpers.keys.successScreen)
      const defaultSuccessScreen = ApplicationHelper.isMobile ? modalEnum.signUpSuccess : modalEnum.appQrCode

      if (successScreen === 'false') return
      if (successScreen === 'guest-message') return modalContext.onOpenModal(modalEnum.guestMessageSuccess)
      modalContext.onOpenModal(defaultSuccessScreen)
    },
    [onClose, setError, modalContext.onOpenModal, sendImageStepEvent]
  )
}

export default useSubmitLogo
